var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid:eye"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0002 28.8C25.2732 28.8 26.4941 28.2942 27.3943 27.3941C28.2945 26.4939 28.8002 25.273 28.8002 24C28.8002 22.7269 28.2945 21.506 27.3943 20.6058C26.4941 19.7057 25.2732 19.2 24.0002 19.2C22.7272 19.2 21.5063 19.7057 20.6061 20.6058C19.7059 21.506 19.2002 22.7269 19.2002 24C19.2002 25.273 19.7059 26.4939 20.6061 27.3941C21.5063 28.2942 22.7272 28.8 24.0002 28.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09961 24C4.15721 14.2632 13.2532 7.19995 24.0004 7.19995C34.7476 7.19995 43.8436 14.2632 46.9012 24C43.8436 33.7368 34.7476 40.8 24.0004 40.8C13.2532 40.8 4.15721 33.7368 1.09961 24ZM33.6004 24C33.6004 26.546 32.589 28.9878 30.7886 30.7882C28.9883 32.5885 26.5465 33.6 24.0004 33.6C21.4543 33.6 19.0125 32.5885 17.2122 30.7882C15.4118 28.9878 14.4004 26.546 14.4004 24C14.4004 21.4539 15.4118 19.0121 17.2122 17.2117C19.0125 15.4114 21.4543 14.4 24.0004 14.4C26.5465 14.4 28.9883 15.4114 30.7886 17.2117C32.589 19.0121 33.6004 21.4539 33.6004 24Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.5498b49202b3d6e92506fb4bac7fb640.svg";
export { ForwardRef as ReactComponent };